var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasCreate)?_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"flex-grow-1"}),(_vm.isAdmin)?_c('select-hospital',{attrs:{"hospitals":_vm.hospitals}}):(_vm.isHospitalContact)?_c('Add',{on:{"click":_vm.open}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }